import CompilerEngine from '../compiler/CompilerEngine';
import { registerStandardBlocks } from '../compiler/StandardBlocks';
import { registerGenericDevice } from '../compiler/blocks/hardware/GenericDevice';
import { registerUltrasonicSensor } from '../compiler/blocks/hardware/UltrasonicSensor';
import { registerIRSensor } from '../compiler/blocks/hardware/IRSensor';
import { registerServoMotor } from '../compiler/blocks/hardware/ServoMotor';
import { registerLEDActuator } from '../compiler/blocks/hardware/LEDActuator';
import { registerPIRSensor } from '../compiler/blocks/hardware/PIRSensor';
import { registerDHTSensor } from '../compiler/blocks/hardware/DHTSensor';
import { registerBuzzerActuator } from '../compiler/blocks/hardware/BuzzerActuator';
import { registerDCMotor } from '../compiler/blocks/hardware/DCMotor';

// Ensure all blocks are registered on boot (this registers BOTH Arduino and Python rules if defined)
registerStandardBlocks();
registerGenericDevice();
registerUltrasonicSensor();
registerIRSensor();
registerServoMotor();
registerLEDActuator();
registerPIRSensor();
registerDHTSensor();
registerBuzzerActuator();
registerDCMotor();

class PythonGenerator {
    constructor() {
        this.boardProfile = { name: 'Raspberry Pi Pico', architecture: 'rp2040', language: 'python' };
    }

    generate(vm) {
        return CompilerEngine.compile(vm, this.boardProfile);
    }
}

export default PythonGenerator;
